/* eslint-disable */
import { resolve } from 'core-js/fn/promise'
// GTM Actions
// -----
// Actions for puching to google tage management
// ----

import { i18n } from '../../main'
import { addToTotal } from '../../utilities/helper'
import MatomoTracker from '../../utilities/matomoTracker'

const matomoTracker = new MatomoTracker();

if (!window.dataLayer) {
	window.dataLayer = []
}

export default {
	// ******************************************
	//	Accomodation
	// ******************************************
	GTM_PUSH_ACCOMMODATION_SEARCH(
		{ commit, state, dispatch },
		{ payload, searchFilters }
	) {
		const ppl = `${
			parseInt(searchFilters.amountAdults) +
			parseInt(searchFilters.amountChildren) +
			parseInt(searchFilters.amountYouths)
		}|${searchFilters.amountChildren}|${searchFilters.amountYouths}|${
			searchFilters.amountAdults
		}`
		let listView = 2
		if (searchFilters.activeTab == 1) {
			listView = 'grid'
		} else if (searchFilters.activeTab == 2) {
			listView = 'list'
		} else {
			listView = 'map'
		}
		try {
			const data = {
				event: 'virtualPageview',
				pagePath: 'ski/lodging/search',
				pageTitle: 'ski lodging search',
				startDate: searchFilters.startDate,
				endDate: searchFilters.endDate,
				dateRange:
					searchFilters.startDate && searchFilters.endDate
						? `${searchFilters.startDate} - ${searchFilters.endDate}`
						: '',
				numberOfPeople: ppl,
				place: searchFilters.place,
				amenities: searchFilters.amenities,
				cottageOrApartmentNumber: searchFilters.cottageOrApartmentNumber,
				campaignCode: searchFilters.campaignCode,
				sortBy: searchFilters.sortBy,
				listView: listView,
				loginStatus: state.user ? 'active' : 'inactive',
				ecommerce: {
					currencyCode: 'SEK',
					impressions: payload.map((each, index) => {
						return {
							name: each.title,
							id: each.unitlid.toString(),
							price: each.price ? each.price.toString() : '',
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/lodging',
							variant: each.type,
							list: 'search ski lodging',
							position: index + 1
						}
					})
				}
			}
			window.dataLayer.push(data)
			matomoTracker.trackPageView(data)
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_ACCOMMODATION_CLICK({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'productClick',
				ecommerce: {
					click: {
						actionField: {
							list: 'search ski lodging'
						},
						products: [
							{
								name: payload.title,
								id: payload.unitlid.toString(),
								price: payload.price ? payload.price.toString() : '',
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/lodging',
								variant: payload.type,
								position: 1
							}
						]
					}
				}
			}
			//window.dataLayer.push(data)
			matomoTracker.productClick(payload.unitlid.toString(), payload.title, 'ski/lodging', payload.price ? payload.price : 0);
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_ACCOMMODATION_ADD_TO_CART({ commit, state, dispatch }, payload) {
		try {
			// const data = {
			// 	event: 'addToCart',
			// 	ecommerce: {
			// 		currencyCode: 'SEK',
			// 		add: {
			// 			products: [
			// 				{
			// 					name: payload.title,
			// 					id: payload.unitlid.toString(),
			// 					price: payload.price ? payload.price.toString() : '',
			// 					brand: 'Kläppen Ski Resort AB',
			// 					category: 'ski/lodging',
			// 					variant: payload.type,
			// 					quantity: 1
			// 				}
			// 			]
			// 		}
			// 	}
			// }

			// window.dataLayer.push(data)

			const data2 = {
				id: payload.unitlid.toString(),
				name: payload.title,
				category: 'ski/lodging',
				price: payload.price ? payload.price.toString() : '',
				quantity: 1
			}
			matomoTracker.addToCart(data2.id, data2.name, data2.category, data2.price, data2.quantity);
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_ACCOMMODATION_REMOVE_FROM_CART(
		{ commit, state, dispatch },
		payload
	) {
		try {
			const data = {
				event: 'removeFromCart',
				ecommerce: {
					currencyCode: 'SEK',
					remove: {
						products: [
							{
								name: payload.title,
								id: payload.unitlid.toString(),
								price: payload.price ? payload.price.toString() : '',
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/lodging',
								variant: payload.type,
								quantity: 1
							}
						]
					}
				}
			}
			window.dataLayer.push(data)
			matomoTracker.removeFromCart(payload.unitlid.toString(), payload.price ? payload.price.toString() : '')
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_ACCOMMODATION_DETAILS({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'virtualPageview',
				ecommerce: {
					detail: {
						actionField: {
							list: 'search ski lodging'
						},
						products: [
							{
								name: payload.title,
								id: payload.unitlid.toString(),
								price: payload.price ? payload.price.toString() : '',
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/lodging',
								variant: payload.type
							}
						]
					}
				}
			}
			window.dataLayer.push(data)
			matomoTracker.trackPageView()
		} catch (error) {
			console.error(error)
		}
	},

	// ******************************************
	//	Skipass
	// ******************************************
	GTM_PUSH_SKIPASS_SEARCH(
		{ commit, state, dispatch },
		{ payload, searchFilters }
	) {
		let skipassList = []
		const activeFilters = state.productList.selectedFilters.map(
			each => each.label
		)
		let counter = 0

		payload.forEach((each, index) => {
			for (let i = 0; i < each.ages.length; i++) {
				const element = each.ages[i]
				counter++
				try {
					skipassList.push({
						name: each.name + ', ' + each.displayLength,
						id: element.poollid.toString(),
						price: element.price.toString(),
						brand: 'Kläppen Ski Resort AB',
						category: 'ski/pass',
						variant: element.name,
						list: 'search ski pass',
						position: counter
					})
				} catch (error) {
					console.error(error)
				}
			}
		})

		const data = {
			event: 'virtualPageview',
			pagePath: 'ski/pass/search',
			pageTitle: 'ski pass search',
			startDate: searchFilters.startDate,
			dateRange: searchFilters.dateRange,
			loginStatus: state.user ? 'active' : 'inactive',
			type: activeFilters.length ? activeFilters.join('|') : 'all',
			ecommerce: {
				currencyCode: 'SEK',
				impressions: skipassList
			}
		}

		// window.dataLayer.push(data)
		matomoTracker.trackPageView(data)
	},

	GTM_PUSH_SKIPASS_CLICK({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'productClick',
				ecommerce: {
					click: {
						actionField: {
							list: 'search ski pass'
						},
						products: [
							{
								name: payload.name + ', ' + payload.displayLength,
								id: payload.poollid.toString(),
								price: payload.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/pass',
								variant: payload.ageGroup,
								position: payload.index + 1
							}
						]
					}
				}
			}
			window.dataLayer.push(data)
			matomoTracker.productClick(payload.poollid.toString(), payload.name + ', ' + payload.displayLength, 'ski/pass', payload.price.toString())
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKIPASS_ADD_TO_CART({ commit, state, dispatch }, payload) {
		try {
			const data1 = {
				event: 'addToCart',
				ecommerce: {
					currencyCode: 'SEK',
					add: {
						products: payload.map(each => {
							const data = {
								id: each.poollid.toString(),
								name: each.name + ', ' + each.displayLength,
								category: 'ski/pass',
								price: each.price.toString(),
								quantity: parseInt(each.qty)
							}

							matomoTracker.addToCart(data.id, data.name, data.category, data.price, data.quantity);

							return {
								name: each.name + ', ' + each.displayLength,
								id: each.poollid.toString(),
								price: each.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/pass',
								variant: each.ageGroup,
								quantity: parseInt(each.qty)
							}
						})
					}
				}
			}
			window.dataLayer.push(data1)
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKIPASS_REMOVE_FROM_CART({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'removeFromCart',
				ecommerce: {
					currencyCode: 'SEK',
					remove: {
						products: [
							{
								name: payload.name + ', ' + payload.displayLength,
								id: payload.poollid.toString(),
								price: payload.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/pass',
								variant: payload.ageGroup,
								quantity: 1
							}
						]
					}
				}
			}

			window.dataLayer.push(data)
			matomoTracker.removeFromCart(payload.poollid.toString(), payload.price.toString())
		} catch (error) {
			console.error(error)
		}
	},

	// ******************************************
	//	Skirantal
	// ******************************************
	GTM_PUSH_SKIRENTAL_SEARCH(
		{ commit, state, dispatch },
		{ payload, searchFilters }
	) {
		let rentalList = []
		const levels = ['Bas', 'Medel', 'Avancerad']
		let counter = 0

		const equipmentcategoryFilters = state.productList.selectedFilters
			.filter(each => each.type == 'equipmentcategory')
			.map(each => each.label)
		const equipmentlevelFilters = state.productList.selectedFilters
			.filter(each => each.type == 'equipmentlevel')
			.map(each => each.label)
		payload.items.forEach((each, index) => {
			for (let i = 0; i < each.ages.length; i++) {
				const element = each.ages[i]

				counter++
				try {
					rentalList.push({
						name:
							each.desc3 +
							(each.equipmentlevel.length == 1
								? ', ' + levels[each.equipmentlevel[0] - 1]
								: ''),
						id: each.poollid + element.cat.replace(' ', '').toString(),
						price: element.price.toString(),
						brand: 'Kläppen Ski Resort AB',
						category: 'ski/equipment',
						variant: element.name,
						list: 'search ski equipment',
						position: counter
					})
				} catch (error) {
					console.error(error)
				}
			}
		})

		const data = {
			event: 'virtualPageview',
			pagePath: 'ski/equipment/search',
			pageTitle: 'ski equipment search',
			startDate: searchFilters.startDate,
			endDate: searchFilters.endDate,
			dateRange:
				searchFilters.startDate && searchFilters.endDate
					? `${searchFilters.startDate} - ${searchFilters.endDate}`
					: '',
			loginStatus: state.user ? 'active' : 'inactive',
			type: equipmentcategoryFilters.length
				? equipmentcategoryFilters.join('|')
				: 'all',
			skill: equipmentlevelFilters.length
				? equipmentlevelFilters.join('|')
				: 'all',
			ecommerce: {
				currencyCode: 'SEK',
				impressions: rentalList
			}
		}

		window.dataLayer.push(data)
		matomoTracker.trackPageView(data)
	},

	GTM_PUSH_SKIRENTAL_CLICK({ commit, state, dispatch }, payload) {
		try {
			const name = payload.name + (payload.levels.length == 1 ? `, ${payload.levels[0].label}` : '')
			const data = {
				event: 'productClick',
				ecommerce: {
					click: {
						actionField: {
							list: 'search ski equipment'
						},
						products: [
							{
								name:
									payload.name +
									(payload.levels.length == 1
										? `, ${payload.levels[0].label}`
										: ''),
								id: payload.poollid + payload.cat.replace(' ', '').toString(),
								price: payload.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/equipment',
								variant: payload.ageGroup,
								position: payload.index + 1
							}
						]
					}
				}
			}
			window.dataLayer.push(data)
			matomoTracker.productClick(payload.poollid.toString(), name, 'ski/equipment', payload.price.toString())
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKIRENTAL_ADD_TO_CART({ commit, state, dispatch }, payload) {
		try {
			const data1 = {
				event: 'addToCart',
				ecommerce: {
					currencyCode: 'SEK',
					add: {
						products: payload.map(each => {
							const data = {
								id: each.poollid + each.cat.replace(' ', '').toString(),
								name: each.name + (each.levels.length == 1 ? `, ${each.levels[0].label}` : ''),
								category: 'ski/equipment',
								price: each.price.toString(),
								quantity: parseInt(each.qty)
							}
							matomoTracker.addToCart(data.id, data.name, data.category, data.price, data.quantity);

							return {
								name:
									each.name + (each.levels.length == 1 ? `, ${each.levels[0].label}` : ''),
								id: each.poollid + each.cat.replace(' ', '').toString(),
								price: each.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/equipment',
								variant: each.ageGroup,
								quantity: parseInt(each.qty)
							}
						})
					}
				}
			}
			window.dataLayer.push(data1)
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKIRENTAL_REMOVE_FROM_CART({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'removeFromCart',
				ecommerce: {
					currencyCode: 'SEK',
					remove: {
						products: [
							{
								name:
									payload.name +
									(payload.levels.length == 1
										? `, ${payload.levels[0].label}`
										: ''),
								id: payload.poollid + payload.cat.replace(' ', '').toString(),
								price: payload.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/equipment',
								variant: payload.ageGroup,
								quantity: 1
							}
						]
					}
				}
			}
			window.dataLayer.push(data)
			matomoTracker.removeFromCart(payload.poollid + payload.cat.replace(' ', '').toString(), payload.price.toString())
		} catch (error) {
			console.error(error)
		}
	},

	// ******************************************
	//	Skischool
	// ******************************************
	GTM_PUSH_SKISCHOOL_SEARCH(
		{ commit, state, dispatch },
		{ payload, searchFilters }
	) {
		let schoolList = []
		const activitytype = state.productList.selectedFilters
			.filter(each => each.type == 'activitytype')
			.map(each => each.label)
		const activitylevel = state.productList.selectedFilters
			.filter(each => each.type == 'activitylevel')
			.map(each => each.label)
		const activitycategory = state.productList.selectedFilters
			.filter(each => each.type == 'activitycategory')
			.map(each => each.label)

		try {
			payload.items.forEach((each, index) => {
				schoolList.push({
					name: each.name,
					id: each.poollid.toString(),
					price: each.price.toString(),
					brand: 'Kläppen Ski Resort AB',
					category: 'ski/school',
					variant:
						payload.levels.find(
							eachLevel => eachLevel.id == each.activitylevel[0]
						).label + `, ${each.minage}-${each.maxage}år`, // ID ska vara text lvl och ålder
					list: 'search ski school',
					position: index + 1
				})
			})

			const data = {
				event: 'virtualPageview',
				pagePath: 'ski/school/search',
				pageTitle: 'ski school search',
				startDate: searchFilters.startDate,
				endDate: searchFilters.endDate,
				dateRange:
					searchFilters.startDate && searchFilters.endDate
						? `${searchFilters.startDate} - ${searchFilters.endDate}`
						: '',
				loginStatus: state.user ? 'active' : 'inactive',
				type: activitytype.length ? activitytype.join('|') : 'all',
				skill: activitylevel.length ? activitylevel.join('|') : 'all',
				ageGroup: activitycategory.length ? activitycategory.join('|') : 'all',
				ecommerce: {
					currencyCode: 'SEK',
					impressions: schoolList
				}
			}

			window.dataLayer.push(data)
			matomoTracker.trackPageView(data)
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKISCHOOL_CLICK({ commit, state, dispatch }, payload) {
		// const activeFilters = state.productList.selectedFilters.map( each => each.label)

		try {
			const data = {
				event: 'productClick',
				ecommerce: {
					click: {
						actionField: {
							list: 'search ski school'
						},
						products: [
							{
								name: payload.name,
								id: payload.poollid.toString(),
								price: payload.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/school',
								variant:
									payload.levels[0].label +
									`, ${payload.fromAge}-${payload.toAge}år`,
								position: payload.index + 1
							}
						]
					}
				}
			}

			window.dataLayer.push(data)
			matomoTracker.productClick(payload.poollid.toString(), payload.name, 'ski/school', payload.price.toString())
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKISCHOOL_DETAILS({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'virtualPageview',
				ecommerce: {
					detail: {
						actionField: {
							list: 'search ski school'
						},
						products: [
							{
								name: payload.item.name,
								id: payload.item.poollid.toString(),
								price: payload.item.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/school',
								variant:
									payload.levels.find(
										eachLevel => eachLevel.id == payload.item.activitylevel[0]
									).label + `, ${payload.item.minage}-${payload.item.maxage}år`,
								position: payload.index + 1
							}
						]
					}
				}
			}

			window.dataLayer.push(data)
			matomoTracker.trackPageView()
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKISCHOOL_ADD_TO_CART({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'addToCart',
				ecommerce: {
					currencyCode: 'SEK',
					add: {
						products: payload.map(each => {
							const data2 = {
								id: each.poollid.toString(),
								name: each.name + (each.levels.length == 1 ? `, ${each.levels[0].label}` : ''),
								category: 'ski/school',
								price: each.price.toString(),
								quantity: parseInt(each.qty)
							}
							matomoTracker.addToCart(data2.id, data2.name, data2.category, data2.price, data2.quantity);
							
							return {
								name:
									each.name + (each.levels.length == 1 ? `, ${each.levels[0].label}` : ''),
								id: each.poollid.toString(),
								price: each.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/school',
								variant:
									each.levels[0].label + `, ${each.fromAge}-${each.toAge}år`,
								quantity: parseInt(each.qty)
							}
						})
					}
				}
			}

			window.dataLayer.push(data)
		} catch (error) {
			console.error(error)
		}
	},

	GTM_PUSH_SKISCHOOL_REMOVE_FROM_CART({ commit, state, dispatch }, payload) {
		try {
			const data = {
				event: 'removeFromCart',
				ecommerce: {
					currencyCode: 'SEK',
					remove: {
						products: [
							{
								name:
									payload.name +
									(payload.levels.length == 1
										? `, ${payload.levels[0].label}`
										: ''),
								id: payload.poollid.toString(),
								price: payload.price.toString(),
								brand: 'Kläppen Ski Resort AB',
								category: 'ski/school',
								variant:
									payload.levels[0].label +
									`, ${payload.fromAge}-${payload.toAge}år`,
								quantity: 1
							}
						]
					}
				}
			}
			window.dataLayer.push(data)
			matomoTracker.removeFromCart(payload.poollid.toString(), payload.price.toString())
		} catch (error) {
			console.error(error)
		}
	},

	// ******************************************
	//	Activities
	// ******************************************
	// GTM_PUSH_ACTIVITIES_SEARCH(
	// 	{ commit, state, dispatch },
	// 	{ payload, searchFilters }
	// ) {
	// 	let schoolList = []
	// 	const activitytype = state.productList.selectedFilters
	// 		.filter(each => each.type == 'activitytype')
	// 		.map(each => each.label)
	// 	const activitylevel = state.productList.selectedFilters
	// 		.filter(each => each.type == 'activitylevel')
	// 		.map(each => each.label)
	// 	const activitycategory = state.productList.selectedFilters
	// 		.filter(each => each.type == 'activitycategory')
	// 		.map(each => each.label)

	// 	try {
	// 		payload.items.forEach((each, index) => {
	// 			schoolList.push({
	// 				name: each.name,
	// 				id: each.poollid.toString(),
	// 				price: each.price.toString(),
	// 				brand: 'Kläppen Ski Resort AB',
	// 				category: 'ski/school',
	// 				variant:
	// 					payload.levels.find(
	// 						eachLevel => eachLevel.id == each.activitylevel[0]
	// 					).label + `, ${each.minage}-${each.maxage}år`, // ID ska vara text lvl och ålder
	// 				list: 'search ski school',
	// 				position: index + 1
	// 			})
	// 		})

	// 		const data = {
	// 			event: 'virtualPageview',
	// 			pagePath: 'ski/school/search',
	// 			pageTitle: 'ski school search',
	// 			startDate: searchFilters.startDate,
	// 			endDate: searchFilters.endDate,
	// 			dateRange:
	// 				searchFilters.startDate && searchFilters.endDate
	// 					? `${searchFilters.startDate} - ${searchFilters.endDate}`
	// 					: '',
	// 			loginStatus: state.user ? 'active' : 'inactive',
	// 			type: activitytype.length ? activitytype.join('|') : 'all',
	// 			skill: activitylevel.length ? activitylevel.join('|') : 'all',
	// 			ageGroup: activitycategory.length
	// 				? activitycategory.join('|')
	// 				: 'all',
	// 			ecommerce: {
	// 				currencyCode: 'SEK',
	// 				impressions: schoolList
	// 			}
	// 		}

	// 		window.dataLayer.push(data)
	// 	} catch (error) {
	// 		console.error(error)
	// 	}
	// },

	// GTM_PUSH_ACTIVITIES_CLICK({ commit, state, dispatch }, payload) {
	// 	// const activeFilters = state.productList.selectedFilters.map( each => each.label)

	// 	try {
	// 		const data = {
	// 			event: 'productClick',
	// 			ecommerce: {
	// 				click: {
	// 					actionField: {
	// 						list: 'search ski school'
	// 					},
	// 					products: [
	// 						{
	// 							name: payload.name,
	// 							id: payload.poollid.toString(),
	// 							price: payload.price.toString(),
	// 							brand: 'Kläppen Ski Resort AB',
	// 							category: 'ski/school',
	// 							variant:
	// 								payload.levels[0].label +
	// 								`, ${payload.fromAge}-${payload.toAge}år`,
	// 							position: payload.index + 1
	// 						}
	// 					]
	// 				}
	// 			}
	// 		}

	// 		window.dataLayer.push(data)
	// 	} catch (error) {
	// 		console.error(error)
	// 	}
	// },

	// GTM_PUSH_ACTIVITIES_DETAILS({ commit, state, dispatch }, payload) {
	// 	try {
	// 		const data = {
	// 			event: 'virtualPageview',
	// 			ecommerce: {
	// 				detail: {
	// 					actionField: {
	// 						list: 'search ski school'
	// 					},
	// 					products: [
	// 						{
	// 							name: payload.item.name,
	// 							id: payload.item.poollid.toString(),
	// 							price: payload.item.price.toString(),
	// 							brand: 'Kläppen Ski Resort AB',
	// 							category: 'ski/school',
	// 							variant:
	// 								payload.levels.find(
	// 									eachLevel => eachLevel.id == payload.item.activitylevel[0]
	// 								).label + `, ${payload.item.minage}-${payload.item.maxage}år`,
	// 							position: payload.index + 1
	// 						}
	// 					]
	// 				}
	// 			}
	// 		}

	// 		window.dataLayer.push(data)
	// 	} catch (error) {
	// 		console.error(error)
	// 	}
	// },

	// GTM_PUSH_ACTIVITIES_ADD_TO_CART({ commit, state, dispatch }, payload) {
	// 	try {
	// 		const data = {
	// 			event: 'addToCart',
	// 			ecommerce: {
	// 				currencyCode: 'SEK',
	// 				add: {
	// 					products: payload.map(each => {
	// 						return {
	// 							name:
	// 								each.name +
	// 								(each.levels.length == 1 ? `, ${each.levels[0].label}` : ''),
	// 							id: each.poollid.toString(),
	// 							price: each.price.toString(),
	// 							brand: 'Kläppen Ski Resort AB',
	// 							category: 'ski/school',
	// 							variant:
	// 								each.levels[0].label + `, ${each.fromAge}-${each.toAge}år`,
	// 							quantity: parseInt(each.qty)
	// 						}
	// 					})
	// 				}
	// 			}
	// 		}

	// 		window.dataLayer.push(data)
	// 	} catch (error) {
	// 		console.error(error)
	// 	}
	// },

	// GTM_PUSH_ACTIVITIES_REMOVE_FROM_CART({ commit, state, dispatch }, payload) {
	// 	try {
	// 		const data = {
	// 			event: 'removeFromCart',
	// 			ecommerce: {
	// 				currencyCode: 'SEK',
	// 				remove: {
	// 					products: [
	// 						{
	// 							name:
	// 								payload.name +
	// 								(payload.levels.length == 1
	// 									? `, ${payload.levels[0].label}`
	// 									: ''),
	// 							id: payload.poollid.toString(),
	// 							price: payload.price.toString(),
	// 							brand: 'Kläppen Ski Resort AB',
	// 							category: 'ski/school',
	// 							variant:
	// 								payload.levels[0].label +
	// 								`, ${payload.fromAge}-${payload.toAge}år`,
	// 							quantity: 1
	// 						}
	// 					]
	// 				}
	// 			}
	// 		}
	// 		window.dataLayer.push(data)
	// 	} catch (error) {
	// 		console.error(error)
	// 	}
	// },

	// ******************************************
	//	Cart Review
	// ******************************************
	GTM_PUSH_REVIEW_CART({ commit, state, dispatch }, payload) {
		const data = {
			event: 'checkout',
			ecommerce: {
				checkout: {
					orderTotal: 0,
					actionField: { step: 1, option: 'Review Cart' },
					products: []
				}
			}
		}

		if (payload.accommodation.length) {
			payload.accommodation.forEach(each => {
				try {
					data.ecommerce.checkout.products.push({
						name: each.title,
						id: each.unitlid.toString(),
						price: each.price.toString(),
						brand: 'Kläppen Ski Resort AB',
						category: 'ski/lodging',
						variant: each.type,
						quantity: 1
					})
					data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
				} catch (error) {
					console.error(error)
				}
			})
		}

		if (payload.skipass.length) {
			let isNew = true

			payload.skipass.forEach(each => {
				isNew = true

				// Add to quantity if id exist
				data.ecommerce.checkout.products.forEach(eachProduct => {
					if (eachProduct.id == each.id) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.checkout.products.push({
							name: each.name + ', ' + each.displayLength,
							id: each.id.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/pass',
							variant: each.ageGroup,
							quantity: 1
						})
						data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		if (payload.skirental.length) {
			let isNew = true

			payload.skirental.forEach(each => {
				isNew = true
				const id = each.poollid + (each.cat ? each.cat.replace(' ', '') : '')

				// Add to quantity if id exist
				data.ecommerce.checkout.products.forEach(eachProduct => {
					if (eachProduct.id == id) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.checkout.products.push({
							name: each.name + ', ' + each.ageGroup,
							id: id.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/equipment',
							variant: each.ageGroup,
							quantity: 1
						})
						data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		if (payload.skischool.length) {
			let isNew = true

			payload.skischool.forEach(each => {
				isNew = true

				// Add to quantity if id exist
				data.ecommerce.checkout.products.forEach(eachProduct => {
					if (eachProduct.id == each.poollid) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.checkout.products.push({
							name: each.name,
							id: each.poollid.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/school',
							variant:
								each.levels[0].label + `, ${each.fromAge}-${each.toAge}år`,
							quantity: 1
						})
						data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		window.dataLayer.push(data)
		//matomoTracker.push(['trackEcommerceCartUpdate', data.ecommerce.checkout.orderTotal])
	},
	// ******************************************
	//	Checkout
	// ******************************************
	GTM_PUSH_CHECKOUT_CART({ commit, state, dispatch }, payload) {
		const data = {
			event: 'checkout',
			ecommerce: {
				checkout: {
					orderTotal: 0,
					actionField: { step: 2, option: 'Payment Information' },
					products: []
				}
			}
		}

		if (payload.accommodation.length) {
			payload.accommodation.forEach(each => {
				try {
					data.ecommerce.checkout.products.push({
						name: each.title,
						id: each.unitlid.toString(),
						price: each.price.toString(),
						brand: 'Kläppen Ski Resort AB',
						category: 'ski/lodging',
						variant: each.type,
						quantity: 1
					})
					data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
				} catch (error) {
					console.error(error)
				}
			})
		}

		if (payload.skipass.length) {
			let isNew = true

			payload.skipass.forEach(each => {
				isNew = true

				// Add to quantity if id exist
				data.ecommerce.checkout.products.forEach(eachProduct => {
					if (eachProduct.id == each.id) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.checkout.products.push({
							name: each.name + ', ' + each.displayLength,
							id: each.id.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/pass',
							variant: each.ageGroup,
							quantity: 1
						})
						data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		if (payload.skirental.length) {
			let isNew = true

			payload.skirental.forEach(each => {
				isNew = true
				const id = each.poollid + (each.cat ? each.cat.replace(' ', '') : '')
				// Add to quantity if id exist
				data.ecommerce.checkout.products.forEach(eachProduct => {
					if (eachProduct.id == id) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.checkout.products.push({
							name: each.name + ', ' + each.ageGroup,
							id: id.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/equipment',
							variant: each.ageGroup,
							quantity: 1
						})
						data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		if (payload.skischool.length) {
			let isNew = true

			payload.skischool.forEach(each => {
				isNew = true

				// Add to quantity if id exist
				data.ecommerce.checkout.products.forEach(eachProduct => {
					if (eachProduct.id == each.poollid) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.checkout.products.push({
							name: each.name,
							id: each.poollid.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/school',
							variant:
								each.levels[0].label + `, ${each.fromAge}-${each.toAge}år`,
							quantity: 1
						})
						data.ecommerce.checkout.orderTotal = addToTotal(data.ecommerce.checkout.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}
		
		window.dataLayer.push(data)
		//matomoTracker.push(['trackEcommerceCartUpdate', data.ecommerce.checkout.orderTotal]);
	},

	// ******************************************
	//	Payment
	// ******************************************

	// ******************************************
	//	Confirmation
	// ******************************************

	GTM_PUSH_CONFIRMATION({ commit, state, dispatch }, payload) {
		const data = {
			event: 'virtualPageview',
			ecommerce: {
				purchase: {
					orderTotal: 0,
					actionField: {
						id: payload.resvid.toString(),
						affiliation: 'Online Store',
						revenue: payload.payedamount.toString(),
						tax: payload.totaltax.toString(),
						shipping: '0.00',
						coupon: ''
					},
					products: []
				}
			}
		}

		if (payload.accommodation.length) {
			payload.accommodation.forEach(each => {
				try {
					data.ecommerce.purchase.products.push({
						name: each.title,
						id: each.unitlid.toString(),
						price: each.price.toString(),
						brand: 'Kläppen Ski Resort AB',
						category: 'ski/lodging',
						variant: each.type,
						quantity: 1
					})

					data.ecommerce.purchase.orderTotal = addToTotal(data.ecommerce.purchase.orderTotal, each.price)
				} catch (error) {
					console.error(error)
				}
			})
		}

		if (payload.skipass.length) {
			let isNew = true

			payload.skipass.forEach(each => {
				isNew = true

				// Add to quantity if id exist
				data.ecommerce.purchase.products.forEach(eachProduct => {
					if (eachProduct.id == each.poollid) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.purchase.products.push({
							name: each.name,
							id: each.poollid.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/pass',
							variant: each.name.split(' ')[each.name.split(' ').length - 1],
							quantity: 1
						})
						data.ecommerce.purchase.orderTotal = addToTotal(data.ecommerce.purchase.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		if (payload.skirental.length) {
			let isNew = true

			payload.skirental.forEach(each => {
				isNew = true
				const id = each.poollid + (each.cat ? each.cat.replace(' ', '') : '')
				// Add to quantity if id exist
				data.ecommerce.purchase.products.forEach(eachProduct => {
					if (eachProduct.id == id) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.purchase.products.push({
							name: each.desc1,
							id: id.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/equipment',
							variant: each.cat,
							quantity: 1
						})
						data.ecommerce.purchase.orderTotal = addToTotal(data.ecommerce.purchase.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}

		if (payload.skischool.length) {
			let isNew = true

			payload.skischool.forEach(each => {
				isNew = true

				// Add to quantity if id exist
				data.ecommerce.purchase.products.forEach(eachProduct => {
					if (eachProduct.id == each.poollid) {
						isNew = false
						eachProduct.quantity = parseInt(eachProduct.quantity) + 1
					}
				})

				if (isNew) {
					try {
						data.ecommerce.purchase.products.push({
							name: each.name,
							id: each.poollid.toString(),
							price: each.price.toString(),
							brand: 'Kläppen Ski Resort AB',
							category: 'ski/school',
							variant: '',
							quantity: 1
						})
						data.ecommerce.purchase.orderTotal = addToTotal(data.ecommerce.purchase.orderTotal, each.price)
					} catch (error) {
						console.error(error)
					}
				}
			})
		}
		
		matomoTracker.checkoutConfirmation(data.ecommerce.purchase.actionField.id, payload.payedamount.toString())
		window.dataLayer.push(data)
	}
}
